import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { shape, arrayOf } from 'prop-types';
import { getMapConfig } from '../../../services/projectService';
import MeasureMapMenu from '../../Map/measureMapMenu';
import { DroneDetailProvider  } from '../../Contexts/DroneDetailContext';

const MapWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;

  .ol-overlaycontainer-stopevent {
    position: absolute;
    width: 100% !important;
    height: 100% !important;
    margin: 0;
  }

  .ol-scale-line {
    position: absolute;
    right: 8px;
    bottom: 8px;

    .ol-scale-line-inner {
      position: absolute !important;
      bottom: 0 !important;
      right: 0 !important;
    }
  }

  .ol-mouse-position {
    position: absolute !important;
    top: 8px !important;
    right: 8px !important;
  }

  .cfm-geolocation {
    position: absolute !important;
    right: 8px !important;
    top: calc(50% + 14px) !important;
    transform: translateY(-50%) !important;
  }

  .ol-zoom {
    position: absolute !important;
    right: 8px !important;
    top: calc(50% + 1.5rem + 2.5rem) !important;
    transform: translateY(-50%) !important;
  }
`;

export const MenuDetailWraper = styled.div`
  position: absolute;
  top: 8px;
  display: flex;
  flex-direction: column;
  z-index: 1;
  width: 3rem;
  left: 8px;
`;

// TODO
// - export config to separate file
// - use one map component
// - fix missing type icon
function DetailMapWithContext({ crs, mapData }) {
  const [loading, setLoading] = useState(true);
  const [mapConfig, setMapConfig] = useState(null);

  useEffect(() => {
    getMapConfig("detailMap")
      .then(data => {
          setMapConfig(data);
          setLoading(false);
      });

      return function cleanup() {
        GIS.Layer.clear();
        GIS.Interaction.clear();
        GIS.Control.clear();
      }
  }, []);

  useEffect(() => {
    if(!loading && mapConfig) {
    /* global GIS */
      GIS.Projection.init(mapConfig.config.projection);
      GIS.Style.init(mapConfig.config.style);
      GIS.Layer.init(mapConfig.config.layer, mapConfig.config.group);
      GIS.Control.init(mapConfig.config.control);
      GIS.Interaction.init(mapConfig.config.map);
      GIS.Map.init(mapConfig.config.map, mapConfig.config.view);

      GIS.Layer.removeFeatures('subproject');
      GIS.Layer.addFeatures('subproject', {
        type: "FeatureCollection",
        name: "Multimedia content",
        features: mapData,
        crs,
      });

      try {
        const extent = GIS.Layer.getLayerExtent('subproject');
        GIS.Map.zoomToExtent(extent, 13);
      } catch (e) {
        console.log("We don't have any media related to you.")
      }
    }
  }, [loading, mapConfig]);

  if(loading || !mapConfig) {
    return null;
  }

  return (
    <>
      <MapWrapper className="cfm-map" id="map">
        <MenuDetailWraper>
          <MeasureMapMenu GIS={GIS}/>
        </MenuDetailWraper>
      </MapWrapper>

    </>
  )
}

DetailMapWithContext.propTypes = {
  crs: shape({}),
  mapData: arrayOf(shape({})).isRequired,
};

DetailMapWithContext.defaultProps = {
  crs: {
    type: "EPSG",
    properties: {
      code: 4326
    }
  },
};


export default function DetailMap({ crs, mapData }) {
  return (
    <DroneDetailProvider>
        <DetailMapWithContext mapData={ crs, mapData }/>
    </DroneDetailProvider>
  );
};
